export default __webpack_public_path__ + "static/media/undraw_business_deal_re_up4u.63956add.svg";